import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'material-ui/Icon';

const iconName = {
  new: 'add',
  open: 'priority_high',
  accepted: 'check',
  rejected: 'block',
};

const LeadIcon = (props) => (
  <div>
    <Icon style={{ fontSize: props.fontSize, color: props.color }}>person</Icon>
    <Icon style={{ fontSize: `${Math.round(props.fontSize * 0.6)}px`, marginLeft: `-${Math.round(props.fontSize * 0.1)}px`, color: props.color }}>
      {iconName[props.type]}
    </Icon>
  </div>
);

LeadIcon.propTypes = {
  fontSize: PropTypes.number,
  color: PropTypes.string,
  type: PropTypes.oneOf(['new', 'accepted', 'rejected', 'open']).isRequired,
};

LeadIcon.defaultProps = {
  fontSize: 20,
  color: '#000000',
};

export default LeadIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/LeadIcon.jsx